const audioHelper = {
  sounds: [],
  playingSounds: [],
  loadCount: 0,


  /**
   * Parses DOM for audio elements and creates an array with ids
   * @param {Array<Object>} soundObjects - An array of sound objects
   * @returns {undefined} undefined
   */
  init(soundObjects, callback) {
    this.callback = callback;
    this.loadingComplete = false;

    for (let i = 0; i < soundObjects.length; i++) {
      const audio = new Audio();
      // audio.addEventListener('canplaythrough', this.onLoadedData.bind(this));
      // audio.addEventListener('load', this.onLoadedData.bind(this), false);
      audio.src = soundObjects[i].path;

      const audioObject = {
        audio,
        elapsedTime: 0,
        endTime: null,
      };

      this.sounds.push(Object.assign(audioObject, soundObjects[i]));

      // can't preload sounds in iOS so might as well just fire
      // the callback
      this.onLoadedData();
    }

    window.requestAnimationFrame(this.checkTime.bind(this));
  },


  /**
   * Callback when all sounds are loaded
   * @returns {undefined} undefined
   */
  onLoadedData() {
    if (!this.loadingComplete) {
      this.loadCount++;

      if (this.loadCount === this.sounds.length) {
        this.loadingComplete = true;
      }

      this.callback('sounds', this.loadingComplete, this.loadCount, this.sounds.length);
    }
  },


  /**
   * Plays a sound with a given id
   * @param {String} id - The id of the sound to play
   * @param {Number} volume - The volume of the sound to play
   * @param {Boolean} loop - If the sound should loop
   * @returns {undefined} undefined
   */
  playSound(id, volume, loop, startTime, endTime) {
    for (let i = 0; i < this.sounds.length; i++) {
      if (this.sounds[i].id === id) {
        this.sounds[i].endTime = null;
        this.sounds[i].audio.pause();
        this.sounds[i].audio.currentTime = startTime ? startTime : 0;
        this.sounds[i].elapsedTime = 0;
        this.sounds[i].startTime = startTime;
        this.sounds[i].audio.loop = loop ? loop : false;
        this.sounds[i].audio.volume = volume ? volume : 1;
        this.sounds[i].audio.play();

        if (endTime) {
          this.sounds[i].endTime = endTime;
        }

        break;
      }
    }
  },


  /**
   * Checks the currentTime for each audio object and stops it if it's played
   * past its endTime property
   * @returns {undefined} undefined
   */
  checkTime() {
    for (let i = 0; i < this.sounds.length; i++) {
      if (this.sounds[i].endTime) {
        this.sounds[i].elapsedTime++;

        if (this.sounds[i].audio.currentTime >=
          this.sounds[i].endTime) {
          this.stopSound(this.sounds[i].id);
        }
      }
    }

    window.requestAnimationFrame(this.checkTime.bind(this));
  },


  /**
   * Stops a sound with a given id
   * @returns {undefined} undefined
   */
  stopSound(id) {
    for (let i = 0; i < this.sounds.length; i++) {
      if (this.sounds[i].id === id) {
        this.sounds[i].audio.currentTime = 0;
        this.sounds[i].audio.pause();

        break;
      }
    }
  },
};

export default audioHelper;



/** WEBPACK FOOTER **
 ** ./assets/js/src/helpers/audio.js
 **/